// #508: GET /api/profiles/habitual-weekdays, the usual weekdays the API
// deduces from the athlete's log. Only the deduction: the correction is the
// profile's own `habitualWeekdays`, which the client already holds.

import type { ApiGet } from "./apiFetch.js";

export type HabitualWeekdaysRead = {
  /** Ascending 0..6, or null when the log is too short to tell. */
  inferred: number[] | null;
  /** null when the answer does not say: the copy then names no window. */
  windowWeeks: number | null;
};

const isWeekdayList = (v: unknown): v is number[] =>
  Array.isArray(v) &&
  v.every((d) => typeof d === "number" && Number.isInteger(d) && d >= 0 && d <= 6);

/** A malformed answer reads as "unknown", never as a guess. */
export const fetchHabitualWeekdays = async (
  apiFetch: ApiGet,
): Promise<HabitualWeekdaysRead> => {
  const res = await apiFetch<{ inferred?: unknown; windowWeeks?: unknown }>(
    "/api/profiles/habitual-weekdays",
  );
  const inferred = isWeekdayList(res?.inferred) && res.inferred.length > 0 ? res.inferred : null;
  const w = res?.windowWeeks;
  const windowWeeks = typeof w === "number" && Number.isInteger(w) && w > 0 ? w : null;
  return { inferred, windowWeeks };
};
